module.exports = __webpack_public_path__ + "images/doctors_healthcare_logo_b7d63d8.png";